// Törədilmiş bildirişlərin "silindi"/"oxundu" vəziyyəti — qalıcı (localStorage).
//
// PROBLEM: Bildirişlər səhifəsi mətbəx və garson bildirişlərini hər poll-da
// CANLI vəziyyətdən yenidən qurur (`overall_status === 'ready'` olan hər ticket
// bir bildiriş verir). Silmək yalnız React state-indən çıxarırdı, ticket isə
// hələ də "ready" olduğu üçün növbəti poll onu yenidən yaradırdı — istifadəçi
// silir, səhifəyə qayıdır, bildiriş yenə orada olur.
//
// HƏLL: silinən/oxunan id-ləri burada saxlayırıq və siyahı quraşdırılarkən
// süzürük. Sistem bildirişlərinin öz store-u var (systemNotifications.ts) —
// onlar həqiqətən silinir, ona görə buraya düşmür.
//
// NİYƏ vaxt damğası ilə: id-lər sonsuz yığılmasın. "Ready" ticket saatlarla
// yaşayır, ona görə 7 gün fazlasıyla kifayətdir; ondan köhnə yazılar oxunanda
// təmizlənir.

const DISMISSED_KEY = 'notif_dismissed_v1';
const READ_KEY = 'notif_read_v1';

/** Bu müddətdən köhnə yazılar oxunuş zamanı silinir. */
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

/** localStorage-ı qorumaq üçün üst hədd (ən köhnələr atılır). */
const MAX_ENTRIES = 500;

type Stamps = Record<string, number>;

function load(key: string): Stamps {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};

    const cutoff = Date.now() - TTL_MS;
    const fresh: Stamps = {};
    for (const [id, ts] of Object.entries(parsed as Stamps)) {
      if (typeof ts === 'number' && ts > cutoff) fresh[id] = ts;
    }
    return fresh;
  } catch {
    return {};
  }
}

function save(key: string, stamps: Stamps): void {
  try {
    let entries = Object.entries(stamps);
    if (entries.length > MAX_ENTRIES) {
      // Ən yenilər qalsın: köhnə id-lər onsuz da TTL ilə gedəcəkdi.
      entries = entries.sort((a, b) => b[1] - a[1]).slice(0, MAX_ENTRIES);
    }
    localStorage.setItem(key, JSON.stringify(Object.fromEntries(entries)));
  } catch {
    /* localStorage dolu/əlçatmaz — vəziyyət yalnız bu sessiyada itir */
  }
}

function add(key: string, ids: string[]): void {
  if (ids.length === 0) return;
  const stamps = load(key);
  const now = Date.now();
  for (const id of ids) {
    if (id) stamps[id] = now;
  }
  save(key, stamps);
}

/** Silinmiş bildiriş id-ləri. Siyahı quraşdırılarkən bunlar buraxılmır. */
export function getDismissedIds(): Set<string> {
  return new Set(Object.keys(load(DISMISSED_KEY)));
}

/** Oxunmuş bildiriş id-ləri. Səhifə yenidən açılanda "oxundu" itməsin. */
export function getReadIds(): Set<string> {
  return new Set(Object.keys(load(READ_KEY)));
}

export function dismissNotifications(ids: string[]): void {
  add(DISMISSED_KEY, ids);
}

export function markNotificationsRead(ids: string[]): void {
  add(READ_KEY, ids);
}

/** Yalnız testlər və "hamısını sıfırla" üçün. */
export function clearNotificationState(): void {
  try {
    localStorage.removeItem(DISMISSED_KEY);
    localStorage.removeItem(READ_KEY);
  } catch {
    /* əlçatmazdırsa əhəmiyyəti yoxdur */
  }
}
